import type { ReactNode } from "react";

import { Modal } from "@pepperstone/pepper-ui-kit";

import { useBodyScrollLock } from "../hooks/useBodyScrollLock";
import { IconButton } from "../IconButton";

export type ModalContentProps = {
  isVisible: boolean;
  close: () => void;
  children: ReactNode;
  maxHeight?: number;
  maxWidth?: number;
  containerClassName?: string;
};

export const ModalContent = ({
  isVisible,
  close,
  children,
  maxHeight = 776,
  maxWidth = 857,
  containerClassName = "",
}: ModalContentProps) => {
  useBodyScrollLock(isVisible);

  return (
    <Modal
      content={
        <div className={`flex flex-col p-4 ${containerClassName}`}>
          <div className="flex flex-row-reverse">
            <IconButton
              icon="cross"
              color="black"
              aria-label="Close"
              onClick={close}
            />
          </div>
          <div className="flex flex-grow">{children}</div>
        </div>
      }
      aria-hidden={!isVisible}
      isVisible={isVisible}
      position="center"
      size="normal"
      maxHeight={maxHeight}
      maxWidth={maxWidth}
    />
  );
};
